import React from 'react';

import PropTypes from 'prop-types';

const CrumbText = ({ prefix, icon, text, varText, suffix, isOverflow, parentIndex, ...rest }) => (
  <span
    className={`cr-topbar__crumb-text-wrapper${isOverflow ? ' cr-topbar__crumb-overflow' : ''}`}
    {...rest}
  >
    {prefix && <span className="cr-topbar__crumb-prefix">{prefix}</span>}
    {icon && <span className="cr-topbar__crumb-icon">{icon}</span>}
    {text && <span className="cr-topbar__crumb-text">{text}</span>}
    {varText && <var className="cr-topbar__crumb-var-text">{varText}</var>}
    {suffix && <span className="cr-topbar__crumb-suffix">{suffix}</span>}
  </span>
);

CrumbText.propTypes = {
  prefix: PropTypes.node,
  icon: PropTypes.node,
  text: PropTypes.node,
  varText: PropTypes.node,
  suffix: PropTypes.node,
  isOverflow: PropTypes.bool,
  parentIndex: PropTypes.number,
};

export default CrumbText;
